module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"highlights":"Highlights"}}}')
  delete Component.options._Ctor
}
